<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">          
            <v-toolbar >
                <v-icon>ballot</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Información de Bureau</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="3">
                        <v-flex sm11>
                            <v-text-field
                                v-if="!searchFilter"
                                v-model="search"
                                append-icon="search"
                                label="Buscar por Documento de Cliente"  
                                single-line
                                hide-details
                            ></v-text-field>
                            <v-text-field
                                v-if="searchFilter"
                                v-model="search"
                                append-icon="search"
                                label="Buscar por Cuit Entidad"  
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>  
                    </v-col>
                    <v-col cols="1">
                        <v-flex sm1>
                            <v-switch label="Cambiar busqueda" v-model="searchFilter"></v-switch>  
                        </v-flex>
                    </v-col>
                    <v-flex sm11>
                      <v-col class="pt-6">
                          <v-btn dark  color="green" @click="getItems">
                              Buscar&nbsp;
                              <v-icon >search</v-icon>                  
                          </v-btn>
                      </v-col>
                      <v-col>
                        <span>{{this.searchFilter? 'Cuit Entidad' : 'Documento Cliente'}}</span>
                      </v-col>
                    </v-flex>
                </v-row>
                <v-card>
                    <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                    <v-icon>list</v-icon>
                    <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-data-table
                    loading-text="Buscando registros"
                    dense
                    :headers="headers"
                    :items="records"
                    :rows-per-page="pagination.itemsPerPage"
                    :options.sync="pagination"
                    v-model="selectedRows"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id"
                    >
                    
                    <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                        No se encontraron registros con los filtros ingresados
                        </v-alert>
                    </template>

                    <template v-slot:item="{ item }">
                        <tr>
                          <td class="text-xs-left caption">{{ item.cuil }}</td>
                          <td class="text-xs-left caption">{{ item.nombre }}</td>
                          <td class="text-xs-left caption">{{ item.domicilio }}</td>
                          <td class="text-xs-left caption">{{ item.contactos }}</td>
                          <td class="text-xs-left caption">{{ item.ingresos }}</td>
                          <td class="text-xs-left caption">{{ item.actividad1 }}</td>
                          <td class="text-xs-left caption">{{ item.clae2 }}</td>
                          <td class="text-xs-left caption">{{ item.actividad2 }}</td>
                          <td class="text-xs-left caption">{{ item.empleador }}</td>
                          <td class="text-xs-left caption">{{ item.cuit }}</td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-card>
            </v-container>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        //itemsPerPageOptions:[5,10,20, 50, 'All'],
        showCurrentPage: true,
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Cuil', value: 'cuil', align: 'left'},
        { text: 'Nombre', value: 'nombre', sortable:false},
        { text: 'Domicilio', value: 'domicilio',sortable:false},
        { text: 'Contactos', value: 'contactos', sortable: false },
        { text: 'Ingresos', value: 'ingresos', sortable: false },
        { text: 'Actividad 1', value: 'actividad1', sortable: false },
        { text: 'CLAE 2', value: 'clae2', sortable: false },
        { text: 'Actividad 2', value: 'actividad2', sortable: false },
        { text: 'Empleador', value: 'empleador', sortable: false },
        { text: 'Empleador Cuit', value: 'cuit', sortable: false }
      ],        
      records: [], // registros
      selectedRows: [],
      search: '',
      searchFilter: false
    };
  },
  async created() {     
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    }
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true

      console.log(this.searchFilter)

      try {
        var result = await http.get('personas/getdatabaseansespersonasjuridicas?searchFilter='+this.searchFilter+'&search='+this.search);                                
        
        this.records = result.list;
        this.totalItems = result.totalCount;

        console.log(this.records)
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()

      try {
        var result = await http.get('cajas/'+id);

        this.model = result;

        this.asociarACanalVenta = !(this.model.canalVentaId === 0);
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0) return;
      
        if(!this.asociarACanalVenta) this.model.canalVentaId = 0;

      if (isUpdate) {
        try{
          var result = await http.put('cajas', JSON.stringify( {caja:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }               
      } else {
        try{
          var result = await http.post('cajas', JSON.stringify( {caja:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          Vue.$log.error(error);
          this.alertError(error)
        }
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación de la caja ' + item.descripcion + '?')) {
        try{
            Vue.$log.debug(item);
            var result = await http.delete('cajas?id='+item.id );
            this.alertSuccess('La caja ha sido eliminada.')
            this.clearAndReload();
        }
        catch(error){
            //Error
            Vue.$log.error(error);
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('La caja no puede ser eliminada debido a que está asociada a otras entidades.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    async loadTiposCaja(){
      this.loading = true;
      try{
        var result = await http.get('tiposcaja');
        Vue.$log.debug('tiposcaja')
        

        this.tiposCaja = result.list;
        Vue.$log.debug(this.tiposCaja)
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadSucursales(){
        this.loading = true;
        try{
            var result = await http.get('sucursales');

            this.sucursales = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadCanalesVenta(){
        this.loading = true;
        try{
            var result = await http.get('canalesventa?limit=9999');

            this.canalesVenta = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    }
  }
}
</script>